module.exports = __webpack_public_path__ + "static/260826_6M 2026_Financial Reporting_HSE Investment Sarl-65e16751cf7b1215a5479d6de874533e.pdf";